export const formatTeacherName = (fullname: string) => {
  const normalized = fullname.replace(/\s+/g, ' ').trim();
  const data = normalized.split(' ');
  if (data.length === 3) {
    const surname = data[0][0].toUpperCase() + data[0].slice(1).toLowerCase();
    const name = data[1][0].toUpperCase() + '.';
    const patronymic = data[2][0].toUpperCase() + '.';
    return `${surname} ${name}${patronymic}`;
  } else {
    return fullname;
  }
};
